import { Component, EventEmitter, Input, OnInit, OnDestroy, Output } from '@angular/core';
import { SpinnerService } from 'shared-components';
import { AdminService } from '../../../services/admin.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-blockchain-entidad',
    templateUrl: './blockchain.component.html'
})
export class BlockChainEntidadControlComponent implements OnInit, OnDestroy {

    public disabledBlockchain: Subject<boolean> = new Subject();
    public disabledBlockchainChildren: Subject<boolean> = new Subject(); // para deshabilitar Cultivos, Designaciones, Confección y Certificado

    public blockchainForm: UntypedFormGroup;

    public registrar 

    public onEdit;

    public showError: boolean;

    private readonly destroy$ = new Subject<void>();

    public yesNoReg = [
        {id: 1, des: this._translate.instant('global.si'), value: 1},
        {id: 2, des: this._translate.instant('global.no'), value: 2}];

    public yesNo = [
        {id: 1, des: this._translate.instant('global.si'), value: true},
        {id: 2, des: this._translate.instant('global.no'), value: false},];
    

    @Input() entidadControl;
    @Output() pushMessage = new EventEmitter<string>();
    @Output() refresh = new EventEmitter<boolean>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _dataProvider: DataProvider,
        private readonly _spinnerService: SpinnerService,
        private readonly _adminService: AdminService,
        private readonly _translate: TranslateService
    ) {}

    ngOnInit() {
        this.blockchainForm = this._fb.group({
            registroBlockchain: [{ value: this.yesNo.find(option => option.value === this.entidadControl.registroBlockchain), disabled: true }, Validators.required],
            registroCultivos: [{ value: this.yesNoReg.find(option => option.value === this.entidadControl.regBlockchainCultivo), disabled: true }, Validators.required],
            registroDesignaciones: [{ value: this.yesNoReg.find(option => option.value === this.entidadControl.regBlockchainDesignacion), disabled: true }, Validators.required],
            registroEtiquetadoExpedicion: [{ value: this.yesNo.find(option => option.value === this.entidadControl.regBlockchainEtqExpedicion), disabled: true }, Validators.required],
            registroCertificado: [{ value: this.yesNo.find(option => option.value === this.entidadControl.regBlockchainCertificadoExp), disabled: true }, Validators.required]
        });

        this.blockchainForm.get('registroBlockchain').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
            if (value?.value && this.onEdit) {
                this.disabledBlockchainChildren.next(false);
            } else {
                this.disabledBlockchainChildren.next(true);
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public enableFilters() {
        this.blockchainForm.enable();
        this.disabledBlockchain.next(false);

        if (this.blockchainForm.get('registroBlockchain').value?.value) {
            this.disabledBlockchainChildren.next(false);
        }

        this.onEdit = true;
    }

    public disableFilters() {
        this.blockchainForm.disable();
        this.disabledBlockchain.next(true);
        this.disabledBlockchainChildren.next(true);
        this.onEdit = false;
    }

    private checkForm() {
        this.showError = this.blockchainForm.invalid;
        if (this.showError) {
            this.pushMessage.emit('global.error.required');
        }
    }

    public save() {
        this.checkForm();
        if (this.blockchainForm.valid) {
            let entidadControl = {
                entidadControlId: this.entidadControl.id,
                registroBlockchain: this.blockchainForm.get('registroBlockchain').value.value,
                regBlockchainCultivo: this.blockchainForm.get('registroCultivos').value.value,
                regBlockchainDesignacion: this.blockchainForm.get('registroDesignaciones').value.value,
                regBlockchainEtqExpedicion: this.blockchainForm.get('registroEtiquetadoExpedicion').value.value,
                regBlockchainCertificadoExp: this.blockchainForm.get('registroCertificado').value.value
            };
            this.showError = false;
            this._spinnerService.showSpinner();
            this._adminService.updateBlockchainSettingsEC(entidadControl).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then((resp) => {
                this.disableFilters();
                this.refresh.emit(true);
                this.pushMessage.emit('global.success.itemUpdated');
            }, (error) => {
                this.showError = true;
                this.pushMessage.emit('global.error.noResponse');
            });
        }
    }

    public cancel() {
        this.blockchainForm.reset({
            registroBlockchain: this.yesNo.find(option => option.value === this.entidadControl.registroBlockchain),
            registroCultivos: this.yesNoReg.find(option => option.value === this.entidadControl.regBlockchainCultivo),
            registroDesignaciones: this.yesNoReg.find(option => option.value === this.entidadControl.regBlockchainDesignacion),
            registroEtiquetadoExpedicion: this.yesNo.find(option => option.value === this.entidadControl.regBlockchainEtqExpedicion),
            registroCertificado: this.yesNo.find(option => option.value === this.entidadControl.regBlockchainCertificadoExp)
        });
        this.disableFilters();
    }

}